<template>
  <div>
    <div class="banner">
      <div class="main">
        <div class="crumb">
          课程中心
          <span v-if="cateInfo">/ {{ cateInfo.name }}</span>
        </div>
        <div class="title">
          <span v-if="cateInfo">{{ cateInfo.name }}</span>
        </div>
        <div class="desc">
          <span v-if="cateInfo">{{ cateInfo.description }}</span>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="main">
        <div class="cates">
          <div class="item active">全部</div>

          <div class="item">插画</div>
          <div class="item">板绘</div>
          <div class="item">原画</div>
        </div>
        <div class="course-list">
          <!-- 成员 start -->
          <div
            v-for="(i, k) in courseList"
            :key="k"
            class="item"
            @click="goCourseDetails(i.id)"
          >
            <div class="cover">
              <el-image fit="cover" :src="i.cover" />
            </div>
            <div class="info">
              <div class="title line-1">{{ i.name }}</div>
              <div class="desc line-2">{{ i.description }}</div>
              <div class="line"></div>
              <div class="learn">
                <icon-svg icon-class="icon_kecheng_1" />
                <span>{{ i.learn_num }}人报名</span>
              </div>
            </div>
          </div>
          <!-- 成员 end -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCateCourses } from '@/network/request'
export default {
  name: 'CourseCate',
  data() {
    return {
      cate_id: 0,
      child_cate_id: 0,
      cateInfo: null,
      courseList: [],
    }
  },
  mounted() {
    this.cate_id = this.$route.params.cate_id || 0
    this.child_cate_id = this.$route.params.child || 0
    this.loadCateCourses()
  },
  methods: {
    loadCateCourses() {
      getCateCourses({
        top_cate: this.cate_id,
        second_cate: this.child_cate_id,
      }).then(({ data }) => {
        if (!this.cateInfo) {
          this.cateInfo = data.result.cate_info
          this.courseList = data.result.data
        }
      })
    },
    goCourseDetails(courseId) {
      this.$router.push({
        name: 'CourseDetails',
        params: {
          course_id: courseId,
        },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.main {
  width: 1240px;
  padding: 0 20px;
  margin: 0 auto;
}
.banner {
  min-width: 1240px;
  width: 100%;
  height: 320px;
  background: #ebf5ff;
  padding-top: 75px;
  .crumb {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #828282;
    height: 17px;
    line-height: 17px;
  }
  .title {
    font-size: 32px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
    line-height: 45px;
    height: 45px;
    margin-top: 43px;
    margin-bottom: 12px;
  }
  .desc {
    width: 431px;
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #828282;
    line-height: 24px;
  }
}
.content {
  min-width: 1240px;
  background: linear-gradient(180deg, #ffffff 0%, rgba(255, 255, 255, 0) 100%);
  .cates {
    padding: 30px 0;
    display: flex;
    .item {
      padding: 10px 20px;
      font-size: 18px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #828282;
      line-height: 25px;
      background: #f8f8fa;
      border-radius: 10px;
      cursor: pointer;
      margin-right: 25px;
      &.active,
      &:hover {
        color: #37a6ff;
        font-weight: 500;
      }
      &.active {
        background: rgba(55, 166, 255, 0.1);
        border: 1px solid #37a6ff;
        cursor: default;
      }
    }
  }
  .course-list {
    min-height: 1050px;
    display: flex;
    justify-content: space-between;
    align-content: flex-start;
    flex-wrap: wrap;

    .item {
      width: 270px;
      height: 320px;
      background: #ffffff;
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.01);
      border-radius: 9px;
      overflow: hidden;
      margin-right: 30px;
      margin-bottom: 30px;
      cursor: pointer;
      transition: transform 0.14s ease-out;

      &:hover {
        transform: scale(1.04, 1.04);
      }
      &:nth-child(4n) {
        margin-right: 0;
      }

      .cover {
        width: 100%;
        height: 180px;
        .el-image {
          width: 100%;
          height: 100%;
        }
      }
      .info {
        padding: 16px 20px;
        position: relative;
        .title {
          font-size: 18px;
          font-weight: 500;
          color: #000000;
          line-height: 25px;
          font-family: PingFangSC-Medium, PingFang SC;
          margin-bottom: 8px;
        }
        .desc {
          font-size: 13px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #828282;
          line-height: 18px;
          height: 36px;
        }
        .line {
          border-bottom: 1px dashed #e4e4e4;
          margin: 8px 0;
        }
        .learn {
          .icon-svg {
            margin-right: 6px;
          }
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #828282;
          line-height: 28px;
        }
      }
    }
  }
}
</style>
